import { APP_BASE_HREF } from '@angular/common';
import { Component, Inject, OnDestroy } from '@angular/core';
import { AbstractControl, FormControl, ValidationErrors, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';

import { LocalizationService } from '../../../Core/Localization/services/localization.service';
import { UsersApi } from '../../../api/users/users.api';
import { messageSeverityEnum } from '../../../Common/Misc/enums/message-severity.enum';
import { validateEmail } from '../../../Common/Misc/helpers/formatting/email.helper';
import { ButtonTypesEnum } from '../../../Common/Forms/enums/button-types.enum';
import { ConfigService } from '../../../Core/Config/services/config.service';
import { partnerResellerConfigs } from '../../config/resellers/reseller-config-model';
import { PartnerResellers } from '../../../Core/Config/enums/partner-resellers.enum';

@Component({
    selector: 'agpr-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    standalone: false
})
export class ForgotPasswordComponent implements OnDestroy {
    readonly buttonStyles = ButtonTypesEnum;

    logoUrl: string;
    logoAltText: string;
    logoRouterLink = undefined;

    loading: boolean;
    email: string;
    usernameFormControl: FormControl<string> = new FormControl<string>(null, [ Validators.required, this.agilityValidateEmail ]);

    justSentPasswordReset: boolean = false;
    subscriptions: Subscription[] = [];

    isResellerDomain: boolean = false;
    reseller: PartnerResellers;

    readonly buttonTypes = ButtonTypesEnum;

    constructor(
        @Inject(APP_BASE_HREF) public appBaseHref: string,
        private usersApi: UsersApi,
        private messageService: MessageService,
        private localizationService: LocalizationService,
        private router: Router,
        private titleService: Title,
        private configService: ConfigService
    ) {
        this.logoUrl = appBaseHref + 'assets/images/agility-logo-horizontal.png';
        this.logoAltText = 'Core.login.agility';
        this.titleService.setTitle(this.localizationService.transform('PasswordReset.browserTitle'));
        this.subscriptions.push(
            this.usernameFormControl.valueChanges.subscribe(change => {
                this.email = change;
            })
        );
        if (this.configService.hasBrandGUID()) {
            this.isResellerDomain = true;
            this.reseller = this.configService.getPartnerReseller();
            const resellerConfig = partnerResellerConfigs.get(this.configService.getPartnerReseller());
            if (resellerConfig) {
                this.logoUrl = resellerConfig.logoUrl;
                this.logoAltText = resellerConfig.logoAltText;
            }
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    sendResetEmail() {
        if (this.usernameFormControl.errors) {
            return;
        }
        this.usersApi.sendPasswordReset(this.email).subscribe(done => {
            this.justSentPasswordReset = true;
            this.messageService.add(
                {
                    severity: messageSeverityEnum.success,
                    summary: this.localizationService.transform('PasswordReset.resetEmail.success', {email: this.email})
                });
        });
    }

    agilityValidateEmail(control: AbstractControl): ValidationErrors | null {
        const email = control.value;

        return validateEmail(email) ? null : { invalidEmailFormat: true };
    }

    backToLogin() {
        this.router.navigate(['Login']);
    }
}
